import * as HttpStatus from 'http-status-codes';
import { AlertController, NavController, Platform } from 'ionic-angular';
import { Api } from '../../../providers/api';
import { Booking } from '../../../entities/booking';
import { Component } from '@angular/core';
import { Config } from '../../../entities/config';
import { DashboardPage } from '../../dashboard/dashboard';
import { Keyboard } from '@ionic-native/keyboard';
import { PostLoginObject, PostLoginResponse } from '../../../interfaces/api';
import { RegisterPage } from '../register/register';
import { Shared } from '../../../providers/shared';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';
import { User } from '../../../entities/user';
import { StatusBar } from '@ionic-native/status-bar';

type InputEvent = 'focus' | 'blur' | 'change';

interface MissingLoginInputs {
    attempt: boolean;
    email: boolean;
    password: boolean;
}

@Component({
    selector: 'page-login',
    templateUrl: 'login.html'
})
export class LoginPage {

    hideRegisterButton: boolean = false;

    missing: MissingLoginInputs = {
        attempt: false,
        email: false,
        password: false,
    };

    userLogin: PostLoginObject = {
        email: '',
        password: '',
    };

    constructor(
        private alertCtrl: AlertController,
        private api: Api,
        private keyboard: Keyboard,
        private navCtrl: NavController,
        private platform: Platform,
        private shared: Shared,
        private spinner: SpinnerDialog,
        private statusBar: StatusBar,
    ) {
        this.platform.ready().then(() => {
            this.keyboard.onKeyboardShow().subscribe(() => {
                this.hideRegisterButton = true;
            });
            this.keyboard.onKeyboardHide().subscribe(() => {
                this.hideRegisterButton = false;
            });
        });
    }

    changeEmail(action: InputEvent) {
        this.missing.email = false;
        if (!this.missing.password)
            this.missing.attempt = false;

        this.hideRegisterButton = action !== 'blur';
    }

    changePassword(action: InputEvent) {
        this.missing.password = false;
        if (!this.missing.email)
            this.missing.attempt = false;

        this.hideRegisterButton = action !== 'blur';
    }

    async login() {
        this.spinner.show();
        this.missing.attempt = true;
        try {

            let response: PostLoginResponse = await this.api.postLogin(this.userLogin);

            if (response.success === undefined || !response.success) {

                this.errorPrompt(null);
                this.missing.attempt = false;

            } else {

                let apiToken: Config;
                if (response.token !== undefined)
                    apiToken = await this.shared.setAndStore('apiToken', response.token);

                let userConfig: Config;
                let user: User;
                if (response.user !== undefined) {
                    user = User.createFromObject(response.user);
                    userConfig = await this.shared.setAndStore('user', user);
                }

                if (apiToken === undefined || userConfig === undefined) this.errorPrompt(response);
                else this.goToDashboardPage();

            }

            this.spinner.hide();

        } catch (e) {
            this.errorPrompt(e);
            this.spinner.hide();
        }
    }

    register(): void {
        this.navCtrl.push(RegisterPage);
    }

    async goToDashboardPage() {
        let bookings: Booking[] = await this.api.getMyBookings();
        this.navCtrl.setRoot(DashboardPage, {bookings: bookings}, {animate: true, direction: 'forward'});
    }

    private errorPrompt(error: any): void {
        let title: string = 'Login failed';
        let message: string = '';

        if (this.userLogin.email.length < 1) {
            this.missing.email = true;
            message = 'Check your login credentials.';
        }

        if (this.userLogin.password.length < 1) {
            this.missing.password = true;
            message = 'Check your login credentials.';
        }

        if (this.missing.password || this.missing.email)
            return this.presentAlert(title, message);

        switch (error.status) {
            case HttpStatus.FORBIDDEN:
                message = 'Forbidden API request.';
                break;
            case HttpStatus.INTERNAL_SERVER_ERROR:
                message = 'An unknown error has occurred.';
                break;
            case HttpStatus.UNPROCESSABLE_ENTITY:
                message = 'Check your login credentials.';
                break;
        }

        return this.presentAlert(title, message);
    }

    private presentAlert(title: string, message: string): void {

        let prompt = this.alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: ['OK']
        });
        prompt.present();
    }

    public ionViewDidEnter() {
        this.statusBar.styleDefault();
    }

    public ionViewWillLeave() {
        this.statusBar.styleLightContent();
    }
}



// WEBPACK FOOTER //
// ./src/pages/auth/login/login.ts